module.exports = __webpack_public_path__ + "static/logo-db3b4d3e2fd38b1992ad2b67846593cc.png";